module.exports = __webpack_public_path__ + "static/media/antirotate.3f446290.svg";